import React, { useMemo } from 'react';
import { Table } from 'antd';
import PropTypes from 'prop-types';

import BudgetTrackingEmptyState from './BudgetTrackingEmptyState';

const DEFAULT_COLUMNS = [
  { title: 'Name', dataIndex: 'name', key: 'name' },
  { title: 'Code', dataIndex: 'code', key: 'code' },
  { title: 'Description', dataIndex: 'description', key: 'description' },
];

export default function CostCodeSelectionTable({
  dataSource,
  columns: columnsProp,
  rowKey = 'id',
  selectedRowKeys,
  onSelectionChange,
  expandable,
  emptyText,
  scrollY,
  style,
}) {
  const columns = columnsProp ?? DEFAULT_COLUMNS;

  const rowSelection = useMemo(() => {
    if (!onSelectionChange) return undefined;
    return {
      selectedRowKeys,
      onChange: onSelectionChange,
      columnWidth: 48,
      getCheckboxProps: () => ({
        className: 'ontraccr-checkbox',
      }),
    };
  }, [selectedRowKeys, onSelectionChange]);

  const emptyState = (
    <BudgetTrackingEmptyState text={emptyText || 'No cost codes available'} />
  );

  return (
    <Table
      className="budget-tracking-table"
      style={{ marginTop: 16, ...style }}
      size="small"
      columns={columns}
      dataSource={dataSource}
      pagination={false}
      rowKey={rowKey}
      rowSelection={rowSelection}
      expandable={expandable}
      scroll={{ x: 'max-content', y: scrollY }}
      locale={{
        emptyText: emptyState,
      }}
      onHeaderRow={() => ({
        className: 'ontraccr-table-header',
      })}
    />
  );
}

CostCodeSelectionTable.propTypes = {
  dataSource: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    code: PropTypes.string,
    description: PropTypes.string,
  })),
  columns: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.node,
    dataIndex: PropTypes.string,
    key: PropTypes.string,
  })),
  rowKey: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  selectedRowKeys: PropTypes.arrayOf(PropTypes.string),
  onSelectionChange: PropTypes.func,
  expandable: PropTypes.shape({
    rowExpandable: PropTypes.func,
    expandedRowRender: PropTypes.func,
    childrenColumnName: PropTypes.string,
  }),
  emptyText: PropTypes.string,
  scrollY: PropTypes.number,
  style: PropTypes.shape({}),
};

CostCodeSelectionTable.defaultProps = {
  dataSource: [],
  columns: null,
  rowKey: 'id',
  selectedRowKeys: [],
  onSelectionChange: null,
  expandable: undefined,
  emptyText: null,
  scrollY: undefined,
  style: undefined,
};
